import { FC } from 'react'
import { useRouter } from 'next/router'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { getIsActive } from '@/utils'
import { TabNavBar } from '@/componentsV2/molecules/TabNavBar'

export const JobTabNavBar: FC = observer(() => {
  const { t } = useTranslation(['p'])
  const router = useRouter()

  const items = [
    {
      label: t('求人を探す'),
      href: `/jobs`,
      isActive: getIsActive(['/jobs'], router, true, true),
      isNew: false,
    },
    {
      label: t('企業から求人を探す'),
      href: '/companies-with-jobs',
      isActive: getIsActive(['/companies-with-jobs'], router, true, true),
      isNew: false,
    },
    {
      label: t('保存した募集'),
      href: `/jobs/saved`,
      isActive: getIsActive(['/jobs/saved'], router, true, true),
      isNew: false,
    },
  ]

  return <TabNavBar items={items} />
})
